import { useEffect } from "react";

import { Button } from "react-bootstrap";
import {
  FieldValues,
  FormProvider,
  useForm,
  UseFormReturn,
} from "react-hook-form";
import { toast } from "react-toastify";

import ServiceOrderingPropertyForm from "./form/ServiceOrderingPropertyForm";
import {
  getServiceOrderTypeValuesByType,
  ServiceOrderType,
} from "../../../_constants/serviceOrder.ts";
import Input from "../../../common/components/form/Input";
import {
  TServiceInventoryStoreState,
  useServiceInventoryStore,
} from "../store/ServiceInventoryStore";

const ErpExpressServiceForm = () => {
  const { dwelling, erpExpress, setData, businessServiceType } =
    useServiceInventoryStore((state) => state);
  const methods: UseFormReturn = useForm<FieldValues>({
    defaultValues: {
      dwelling,
      erpExpress,
    },
  });

  // update lessor when dwelling is updated
  useEffect(() => {
    const dwelling = methods.watch("dwelling");
    if (dwelling) {
      methods.setValue("erpExpress.lessor", dwelling.lessor);
    } else {
      methods.setValue("erpExpress.lessor", null);
    }
  }, [methods.watch("dwelling")]);

  const onSubmit = (data: TServiceInventoryStoreState) => {
    const result = {
      ...data,
      businessServiceType,
    };
    setData(result);
    toast.success(
      `${
        getServiceOrderTypeValuesByType(ServiceOrderType.ERP_EXPRESS)?.label
      } ajouté au panier`
    );
  };
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3 serviceOrdering_erpExpress"
      >
        <ServiceOrderingPropertyForm
          name="dwelling"
          rules={{ required: "Veuillez renseigner un bien" }}
        />
        <div className="border-bottom" />
        <div className="serviceOrdering_erpExpress-inputs">
          <Input
            control={methods.control}
            label="Vendeur / bailleur"
            name="erpExpress.lessor"
            defaultValue=""
            rules={{ required: "Veuillez renseigner un vendeur / bailleur" }}
          />
          <Input
            control={methods.control}
            label="Acquéreur / locataire"
            name="erpExpress.buyer"
            defaultValue=""
            rules={{ required: "Veuillez renseigner un acquéreur / locataire" }}
          />
        </div>
        <div className="d-flex justify-content-end">
          <Button variant={"primary"} type={"submit"}>
            {erpExpress ? "Modifier" : "Ajouter"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default ErpExpressServiceForm;
